module.exports = __webpack_public_path__ + "img/03_noff_close_L3.00178b4a.svg";